import logo from './logo.svg';
import './App.css';
import OnboardingForm from './pages/OnbaordingForm';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      <OnboardingForm />
      <ToastContainer />
    </div>
  );
}

export default App;
